/** @format */
import { CourseUnitPrerequisite, ModulePrerequisite } from 'common-typescript/types';

export function isCourseUnitPrerequisite(prerequisite: any): prerequisite is CourseUnitPrerequisite {
    return prerequisite?.type === 'CourseUnit' && 'courseUnitGroupId' in prerequisite;
}

export function isModulePrerequisite(prerequisite: any): prerequisite is ModulePrerequisite {
    return prerequisite?.type === 'Module' && 'moduleGroupId' in prerequisite;
}
